import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { ValuePickerModalService } from "./value-picker-modal.service";
import { ValuePickerComponent } from "./value-picker.component";

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, TranslocoModule],
	declarations: [ValuePickerComponent],
	providers: [ValuePickerModalService],
})
export class ValuePickerModule {}
